import { Auth } from 'aws-amplify';

export default async () => {
    const currentSession = await Auth.currentSession();
    const bearerToken = `Bearer ${currentSession.idToken.jwtToken}`;
    const companyId = sessionStorage.getItem('companyId');

    return {
        headers: {
            'Content-Type':  'application/json',
            'Authorization': bearerToken,
            'K2A-Company':   companyId
        }
    };
};
